<template>
    <div>
        <div class="lista-smge" v-if="!loading">
            <div class="acoes-freq">
                <el-checkbox v-model="todasDisciplinas">Todas as disciplinas</el-checkbox>
            </div>
            <ul>
                <li>
                    <h3>Selecione uma disciplina</h3>
                </li>
                <template v-for="(item, i) in disciplinas">
                    <li :key="i" @click="disciplinaSelecionada(item)">
                        <div class="box-data">
                            <h3>{{ `${item.nome_area}`  }}</h3>
                        </div>
                        <i class="fas fa-angle-right"></i>
                    </li>
                </template>
                <p v-if="disciplinas.length == 0" class="u-text-center">
                    Você não possui nenhuma disciplina
                </p>
            </ul>
        </div>
    </div>
</template>
<script>

export default {
    props: ['param', 'turmaSelected'],
    data: () => ({
        todasDisciplinas: false,
        loading: true,
        disciplinasAll: [],
        disciplinasProf: [],
        disciplinas: [],
        possuiDiciplina: false,
    }),
    mounted () {

        this.disciplinasAll = this.param.disciplinas;
        this.disciplinasProf = this.turmaSelected.disciplinas;
        this.disciplinas = this.disciplinasProf;    
        this.loading = false;
    },
    methods:{
        disciplinaSelecionada(disciplina){

            this.$router.push(`/admin/diario/frequencia?data=${this.$route.query.data}&turma=${this.$route.query.turma}&disciplina=${disciplina.id}`);
        }
    },
    watch: {
        todasDisciplinas: {
            immediate: true,
            handler (value) {

                if(value){
                    this.disciplinas = this.disciplinasAll;
                }else{
                    this.disciplinas = this.disciplinasProf;
                }
            }
        },
    },
}
</script>
<style>
    .acoes-freq{
        text-align: right;
    }
    .lista-smge {
        max-width: 100%;
        margin: 0 auto;
        z-index: 1;
    }
    .lista-smge ul {
        list-style: none;
        padding-left: 0px;
    }
    .lista-smge li:not(:first-child) {
        color: #404040;
        border-bottom: 1px solid #eaeaea;
        cursor: pointer;
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .lista-smge li:first-child {
        padding: 10px;
        border-top: 1px solid #eaeaea;
        background-color: #f1f1f1;
    }
    .lista-smge h3 {
        margin: 0;
        font-weight: 400;
        color: #2d2d2d;
        font-size: 16px;
        letter-spacing: -.5px;
    }
    .lista-smge .freq-sub-titulo{
        font-weight: 300;
        color: #818181;
    }
    .lista-smge .box-data {
        padding-left: 10px;
    }
</style>
